import Icon from '../components/Icon.vue'

Icon.register({
  'check-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80V432C448 458.5 426.5 480 400 480zM195.3 381.9L379.3 197.9C385.6 191.7 385.6 181.6 379.3 175.3L356.7 152.7C350.4 146.4 340.3 146.4 334.1 152.7L184 302.7 113.9 232.7C107.7 226.4 97.6 226.4 91.3 232.7L68.7 255.3C62.4 261.6 62.4 271.7 68.7 277.9L172.7 381.9C178.9 388.2 189.1 388.2 195.3 381.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/check-square.js
// module id = JT66
// module chunks = 144